export type CostTier = {
  readonly id: string;
  readonly rank: string;
  readonly title: string;
  readonly lede: string;
};

export type FigureLegendEntry = {
  readonly label: string;
  readonly tone: "brand" | "muted";
};

export const COST_TIERS: readonly CostTier[] = [
  {
    id: "obvious",
    rank: "01 — The obvious cost",
    title: "Shared Source of Truth",
    lede: "LOOP gives development teams a shared digital workflow with one predictable monthly seat fee, replacing much of the fragmented development process—and the unpredictable costs that come with each round.",
  },
  {
    id: "hidden",
    rank: "02 — The hidden cost",
    title: "Where change gets lost",
    lede: "When a design changes, teams often need to re-explain, reinterpret and re-create downstream information. LOOP preserves design intent and knit logic, reducing unnecessary handoffs.",
  },
  {
    id: "strategic",
    rank: "03 — The strategic cost",
    title: "Move with the market",
    lede: "Turn changing trends into design updates without restarting the development process. Make a change once, regenerate what comes next, and resolve more decisions digitally before physical sampling.",
  },
];

export const COST_FIGURE_LEGEND: readonly FigureLegendEntry[] = [
  { label: "Traditional workflow", tone: "muted" },
  { label: "LOOP", tone: "brand" },
];

export const COST_CHART = {
  caption:
    "Knit development has real material, programming and production costs. A shared digital workflow makes the dependencies visible earlier, before physical validation.",
  note: "Illustrative — this shows workflow dependencies, not audited amounts.",
  ariaLabel:
    "Illustrative workflow dependencies across twelve months. A shared digital LOOP workflow keeps design, knit logic and production inputs connected, while a coordinated workflow surfaces those inputs at different stages.",
} as const;

export const ROUTE_DIAGRAM = {
  caption:
    "Both routes rely on the same expertise and end in physical validation. LOOP reduces the time it takes to get there, giving teams the confidence to keep iterating.",
  note: "Illustrative — coordination needs vary by product and production partner.",
  ariaLabel:
    "Two routes from design intent to physical validation. LOOP connects design intent to knit-ready data before prototyping; coordinated workflows move that information between design, programming and manufacturing at each stage.",
} as const;

export const OPPORTUNITY_WINDOW = {
  caption:
    "Two development paths, one trend window. LOOP makes it easier to adjust, iterate, and prototype while the trend is still evolving, while traditional workflows can leave less room to respond before the window closes.",
  note: "Illustrative — the window's width varies by category.",
  ariaLabel:
    "A design change moving through a shared workflow. LOOP updates downstream knit data in minutes, while any physical prototype still needs machine setup, yarn behavior, finishing and quality validation.",
} as const;
